module.exports = __webpack_public_path__ + "static/img/13.f4065c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/sp/13.png
// module id = N8mn
// module chunks = 0